import type { CompetitorFunnelRow } from '../types';
import { getFunnelInsights } from '../builders';

export function FunnelInsightBox({ data }: { data: CompetitorFunnelRow[] }) {
  const { bestConversion, steepestDrop } = getFunnelInsights(data);
  const hasBest = Boolean(bestConversion.brand) && Number.isFinite(bestConversion.rate);
  const hasDrop = Boolean(steepestDrop.brand) && Number.isFinite(steepestDrop.drop);
  if (!hasBest && !hasDrop) return null;
  return (
    <div style={{
      width: '320px',
      flexShrink: 0,
      backgroundColor: '#f5f9ff',
      border: '1px solid rgba(40,169,210,0.18)',
      borderRadius: '10px',
      borderLeft: '3px solid #28a9d2',
      padding: '18px 20px',
    }}>
      <p style={{ fontSize: 'var(--text-xs)', fontWeight: 600, letterSpacing: '0.4px', color: '#28a9d2', marginBottom: '12px' }}>
        Funnel Insights
      </p>
      {hasBest && (
        <p style={{ fontSize: 'var(--text-sm)', color: 'var(--foreground)', lineHeight: '1.55', marginBottom: '14px' }}>
          {bestConversion.brand} converts most efficiently through the funnel, holding onto {bestConversion.rate.toFixed(0)}% of its mentions all the way to a primary recommendation.
        </p>
      )}
      {hasDrop && (
        <p style={{ fontSize: 'var(--text-sm)', color: 'var(--foreground)', lineHeight: '1.55' }}>
          The steepest drop happens between {steepestDrop.fromLabel} and {steepestDrop.toLabel} for {steepestDrop.brand}, a fall of {steepestDrop.drop.toFixed(1)} percentage points.
        </p>
      )}
    </div>
  );
}
